import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import FieldError from '../FieldError';
import FieldHint from '../FieldHint';
import { getLabel } from '../utils';

import '../form.scss';

const CheckboxCollection = ({
    hint, error, label, collection, name, required, value, onChange,
}) => {
    const labelText = getLabel(label, name, required);
    const hasError = error && error.length > 0;

    const handleChange = React.useCallback((e) => {
        let newValue;
        if (e.target.checked) {
            newValue = [...value, e.target.value];
        } else {
            newValue = value.filter((i) => i !== e.target.value);
        }

        onChange(newValue);
    }, [value, onChange]);

    return (
        <Row
            as="fieldset"
            className={classNames('checkbox-collection row', { 'is-invalid': hasError })}
        >
            <Col as="legend" xs={12}>{ labelText }</Col>
            {
                collection.map((i) => (
                    <Col
                        key={i.id}
                        xs={12}
                        md={6}
                        lg={4}
                        xl={3}
                    >
                        <Form.Check
                            type="checkbox"
                            id={`${name}_${i.id}`}
                            label={i.title}
                            name={name}
                            value={i.id}
                            checked={value.includes(i.id)}
                            onChange={handleChange}
                            isInvalid={hasError}
                        />
                    </Col>
                ))
            }
            <Col xs={12}>
                <FieldHint hint={hint} />
                <FieldError error={error} />
            </Col>
        </Row>
    );
};

CheckboxCollection.propTypes = {
    collection: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    })),
    error: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    onChange: PropTypes.func.isRequired,
};

export default React.memo(CheckboxCollection);
